import { useState, useEffect, useRef, useCallback } from 'react';
import { profileCompletedApi } from 'data/api/userApi';

const POLL_INTERVAL = 5000; // Poll every 5 seconds

export const useFilemakerSyncStatus = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const pollingIntervalRef = useRef<NodeJS.Timeout | null>(null);

  const checkFilemakerSyncStatus = useCallback(async () => {
    try {
      const response = await profileCompletedApi();
      // Show banner when status is true but filemakerSynced is false
      const shouldShow = response.status && !response.filemakerSynced;
      setShowBanner(shouldShow);
      setIsLoading(false);

      // If filemakerSynced is true, stop polling
      if (response.filemakerSynced) {
        if (pollingIntervalRef.current) {
          clearInterval(pollingIntervalRef.current);
          pollingIntervalRef.current = null;
        }
        setShowBanner(false);
      }
    } catch (error) {
      console.error('Error checking filemaker sync status:', error);
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    // Initial check
    checkFilemakerSyncStatus();

    // Set up polling interval - poll continuously until filemakerSynced is true
    pollingIntervalRef.current = setInterval(() => {
      checkFilemakerSyncStatus();
    }, POLL_INTERVAL);

    // Cleanup on unmount
    return () => {
      if (pollingIntervalRef.current) {
        clearInterval(pollingIntervalRef.current);
        pollingIntervalRef.current = null;
      }
    };
  }, [checkFilemakerSyncStatus]);

  return { showBanner, isLoading };
};

